import axios from "axios"; 
const currentURL = window.location.origin ;
const NODE_ENV = process.env.NODE_ENV;
export const AxiosInstance = axios.create({
  baseURL : NODE_ENV === 'production' ? currentURL + '/api/': 'http://127.0.0.1:4001/',
  withCredentials: true,
});


